export const REQUIRED_ONBOARDING = 'REQUIRED_ONBOARDING';
export const PROMOTIONS = 'PROMOTIONS';
export const PRODUCTS = 'PRODUCTS';
export const OWNERSHIP = 'OWNERSHIP';
export const RETAIL = 'RETAIL';
export const CONTACTS = 'CONTACTS_IN_CRM';
export const MARKETING_CONTACTS = 'MARKETING_CONTACTS';
export const PHONE_NUMBERS = 'PHONE_NUMBERS';
export const SETTINGS = 'SETTINGS';
export const PURCHASE_MOTIONS = 'PURCHASE_MOTIONS';
export const PUBLIC = 'PUBLIC_META_DATA';
export const COUNTRY = 'COUNTRY';
export const PRODUCT_INVENTORY = 'PRODUCT_INVENTORY';
export const FEATURES = 'FEATURES';
export const FEATURES_MARKETING = 'FEATURES_MARKETING';
export const FEATURES_SALES = 'FEATURES_SALES';
export const FEATURES_SERVICE = 'FEATURES_SERVICE';
export const FEATURES_OPERATIONS = 'FEATURES_OPERATIONS';
export const FEATURES_CMS = 'FEATURES_CMS';
export const COMPARE = 'COMPARE';
export const BUSINESS_OBJECTIVES = 'BUSINESS_OBJECTIVES';
export const SEATS_INVENTORY = 'SEATS_INVENTORY';
export const ACTIVE_TRIALS = 'ACTIVE_TRIALS';
export const COMPANY_DETAILS = 'COMPANY_DETAILS';
export const RECOMMENDED_HUB = 'RECOMMENDED_HUB';